import { useSearchParams } from "react-router-dom";
import Tabs from "../../components/ui/Tabs";
import { useToEvaluate } from "./usePerformanceQueries";
import QueryState from "./components/QueryState";
import EvaluationsTable from "./components/EvaluationsTable";
import ui from "../../components/ui/ui.module.css";

const VIEW_TABS = [
  { id: "open", label: "Open" },
  { id: "history", label: "History" },
];

const EvaluationsToRateView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("view") === "history" ? "history" : "open";
  const query = useToEvaluate(view === "history");

  return (
    <div className={ui.page}>
      <div className={ui.pageHeader}>
        <div>
          <h4 className="page-title">Evaluations to Rate</h4>
          <p className="page-subtitle">
            Performance evaluations where you are the evaluator.
          </p>
        </div>
      </div>

      <div className={ui.card}>
        <Tabs
          tabs={VIEW_TABS}
          active={view}
          onChange={(id) => setSearchParams({ view: id }, { replace: true })}
        />
        <QueryState query={query} loadingText="Loading evaluations…">
          {(rows) => (
            <EvaluationsTable
              rows={rows}
              basePath="/me/evaluations-to-rate"
              emptyMessage={
                view === "open"
                  ? "Nothing to rate right now."
                  : "No evaluations yet."
              }
            />
          )}
        </QueryState>
      </div>
    </div>
  );
};

export default EvaluationsToRateView;
